/* eslint-disable @typescript-eslint/no-explicit-any*/
import {
  USER_IMPERSONATION_LIST,
  USER_IMPERSONATION_LAST_ACCESS,
} from '~/actions/actionTypes';

const initialState: any = {
  received: [],
  sent: [],
  lastAccess: [],
};

const userImpersonationReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case USER_IMPERSONATION_LIST:
      return action.payload;

    case USER_IMPERSONATION_LAST_ACCESS:
      return {
        ...state,
        lastAccess: action.payload,
      };

    default:
      return state;
  }
};

export default userImpersonationReducer;
